export const ERROR_UNKNOWN = "ERROR_UNKNOWN";
export const DEFAULT_ERROR_UNKNOWN = "An unknown error has occurred.";
export const getErrors = (issues) => issues.map(({ message }) => (message.startsWith("ERROR_") ? message : ERROR_UNKNOWN));
export const translateErrors = (zodIssues, errorLookup) => {
    const errors = getErrors(zodIssues);
    const translatedErrors = errors.length ? errors.map(error => errorLookup.get(error) || DEFAULT_ERROR_UNKNOWN) : [];
    return [...new Set(translatedErrors)];
};
//# sourceMappingURL=Validation.js.map